import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { ReactComponent as AddIcon } from '~/assets/images/plus-logo.svg';
import { ReactComponent as SshKeyIcon } from '~/assets/images/sshkey-icon.svg';
import useResponsive from '~/hooks/useResponsive';
import EmptySectionCard from '~/Nova/scenes/Site/components/EmptySectionCard';

interface SSHKeysEmptyCardProps {
  heading: string;
  description: string;
  buttonLabel: string;
  onAdd: () => void;
  disabled?: boolean;
}

const iconWrapperSx = {
  width: 36,
  height: 36,
  borderRadius: 2,
  bgcolor: 'secondary.light',
  flexShrink: 0,
};

const SSHKeysEmptyCard = ({
  heading,
  description,
  buttonLabel,
  onAdd,
  disabled = false,
}: SSHKeysEmptyCardProps) => {
  const theme = useTheme();
  const { isMobile } = useResponsive();
  const isMobileView = isMobile();

  return (
    <EmptySectionCard variant="transparent">
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={1}
        sx={{
          py: 6,
        }}
      >
        <Stack alignItems="center" justifyContent="center" sx={iconWrapperSx}>
          <SshKeyIcon
            style={{
              color: theme.palette.primary.main,
              fontSize: 'small',
            }}
          />
        </Stack>
        <Typography variant="h3">{heading}</Typography>
        <Typography
          align="center"
          variant="body2"
          sx={{
            maxWidth: 'sm',
            lineHeight: 1.45,
            color: 'text.secondary',
          }}
        >
          {description}
        </Typography>
        <Button
          variant="contained"
          onClick={onAdd}
          disabled={disabled}
          fullWidth={isMobileView}
          data-testid="ssh-empty-state-button"
          startIcon={<AddIcon />}
        >
          {buttonLabel}
        </Button>
      </Stack>
    </EmptySectionCard>
  );
};

export default SSHKeysEmptyCard;
